import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TutorDialogData } from 'models';
import { BtnComponent } from 'src/app/components/utilities/btn/btn.component';



@Component({
  selector: 'app-tutor',
  templateUrl: './tutor.component.html',
  styleUrls: ['./tutor.component.css'],
  standalone: true,
  imports: [
    /* Angular */
    CommonModule,

    /* App */
    BtnComponent,
  ]
})
export class TutorComponent {

  constructor(
    public dialogRef: MatDialogRef<TutorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TutorDialogData,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeDialog(fActionValue) {
    this.dialogRef.close(fActionValue)
  }
}
